/* eslint-disable @typescript-eslint/no-explicit-any */
export var eventBus = true ? window.eventBus : undefined;